import { render, staticRenderFns } from "./QuestionSolved.vue?vue&type=template&id=58c8e761&scoped=true&"
import script from "./QuestionSolved.vue?vue&type=script&lang=js&"
export * from "./QuestionSolved.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSolved.vue?vue&type=style&index=0&id=58c8e761&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c8e761",
  null
  
)

export default component.exports